import { FieldError, FieldErrors, FieldValues, Resolver } from 'react-hook-form';

export const withDateInputValidation =
  <T extends FieldValues>(resolver: Resolver<T>, getDateInputError: () => FieldError | undefined): Resolver<T> =>
  async (...args) => {
    const result = await resolver(...args);
    const dateInputError = getDateInputError();

    // The schema validates the applied date, so preserve errors from an invalid draft.
    if (dateInputError?.type === 'dateInput') {
      return { values: {}, errors: { ...result.errors, anchorTime: dateInputError } as FieldErrors<T> };
    }

    return result;
  };
